import ScanResultModal from "./components/ScanResultModal";
import {Outlet} from "react-router-dom";
import {FC, useEffect, useRef, useState} from "react";
import {ScanResult} from "./types";
import * as Tone from 'tone';

const MainLayout: FC = () => {
    const [scanResult, setScanResult] = useState<ScanResult | null>(null);
    const validSynth = useRef<Tone.Synth | null>(null);
    const invalidSynth = useRef<Tone.Synth | null>(null);

    useEffect(() => {
        const initAudio = async () => {
            await Tone.start();
            validSynth.current = new Tone.Synth({ oscillator: { type: 'sine' } }).toDestination();
            invalidSynth.current = new Tone.Synth({ oscillator: { type: 'square' } }).toDestination();
        };
        document.body.addEventListener('click', initAudio, { once: true });
        return () => {
            document.body.removeEventListener('click', initAudio);
            validSynth.current?.dispose();
            invalidSynth.current?.dispose();
        };
    }, []);

    const handleScan = (isValid: boolean) => {
        if (isValid) {
            validSynth.current?.triggerAttackRelease("C5", "0.5");
            setScanResult({ status: 'valid' });
        } else {
            invalidSynth.current?.triggerAttackRelease("C#3", "0.5");
            setScanResult({ status: 'invalid' });
        }
        setTimeout(() => setScanResult(null), 2500);
    };

    return (
        <div className="bg-slate-900 font-sans text-slate-200 min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
            <style>{`
                input[type='number']::-webkit-inner-spin-button,
                input[type='number']::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
                input[type='number'] { -moz-appearance: textfield; }
                input[type="date"], input[type="time"] { color-scheme: dark; }
            `}</style>

            <Outlet context={{ handleScan }} />

            <ScanResultModal result={scanResult} onClose={() => setScanResult(null)} />
        </div>
    );
};

export default MainLayout